export default __webpack_public_path__ + "static/media/vodafone.29851f2e.jpg";